import React from 'react';

import { Text } from '@common/components';
import { DisputeStateType } from '@common/graphql';
import { ColorsType } from '@common/tokens';

const DISPUTE_COLOR_STYLE_MAP: Record<DisputeStateType, ColorsType> = {
  open: 'skyRegular',
  rejected: 'coral',
  retracted: 'darkGrey',
  approved: 'grassDarkest',
  resolved: 'textDefault',
  archived: 'darkGrey',
  redirected: 'skyRegular',
};

export const DISPUTE_LABEL_OVERWRITE: Record<DisputeStateType, string> = {
  open: 'Open',
  rejected: 'Rejected',
  retracted: 'Retracted',
  approved: 'Approved',
  resolved: 'Resolved',
  archived: 'Archived',
  redirected: 'Open',
};

const disputeStateLabel = (
  updatedBy: string | undefined
): Record<DisputeStateType, string> => ({
  ...DISPUTE_LABEL_OVERWRITE,
  redirected: `Open, Sent to ${updatedBy}`,
});

export const DisputeState = ({
  state,
  createdBy,
}: {
  state: DisputeStateType;
  createdBy?: 'Supplier' | 'Organization' | undefined;
}) => (
  <Text weight="bolder" color={DISPUTE_COLOR_STYLE_MAP[state]}>
    {disputeStateLabel(createdBy)[state] || state}
  </Text>
);
